/**
 * Single source of truth for the Entity Details form field names.
 *
 * Per the Modular Form Architecture Migration: field modules and the composed
 * schema reference these constants instead of raw strings so renames stay safe.
 */
export const WORKSPACE_DETAILS_FORM_FIELDS = {
  abnStatus: 'abnStatus',
  addressCity: 'addressCity',
  addressCountry: 'addressCountry',
  addressLine1: 'addressLine1',
  addressPostcode: 'addressPostcode',
  addressState: 'addressState',
  businessNumber: 'businessNumber',
  businessNumberCountry: 'businessNumberCountry',
  businessNumberVerified: 'businessNumberVerified',
  canProceed: 'canProceed',
  categories: 'categories',
  contacts: 'contacts',
  entityName: 'entityName',
  entityType: 'entityType',
  gstStatus: 'gstStatus',
  phone: 'phone',
  representsClients: 'representsClients',
  taxResidency: 'taxResidency',
  website: 'website',
  workspaceName: 'workspaceName',
  workspaceType: 'workspaceType',
} as const;
